import React from 'react';
import { FiEdit2 } from "react-icons/fi";
import { AiOutlineDelete } from "react-icons/ai";
import { Input } from '../Ui/Input';
import { Button } from '../Ui/Button';
import { FormContainer, FieldsContainer, WorkFlowActionsContainer, AddedFieldsContainer, DataContainer } from './styles';

const WorkflowActions = ({ isArabic, handleInputChange, actionName, actionLabel, arabicActionName, arabicActionLabel, actionID, actions, handleWorkFlowAction, handleEditWorkflowAction, handleRemoveAction }) => {
    return (
        <FormContainer>
            <FieldsContainer>
                <WorkFlowActionsContainer>
                    <h4 style={{color: '#333', margin: '0 0 15px 0'}}>Workflow Actions</h4>
                    <div>
                        <Input label={'Name'} inline={true} value={actionName} type={'text'} placeholder={'Type your workflow action in english'} onChange={e => handleInputChange('actionName', e.target.value)} />
                        <Input label={'Label'} inline={true} value={actionLabel} type={'text'} placeholder={'Type your workflow action in english'} onChange={e => handleInputChange('actionLabel', e.target.value)} />
                        <Input label={'Arabic Name'} inline={true} value={arabicActionName} type={'text'} placeholder={'Type your workflow action in arabic'} onChange={e => handleInputChange('arabicActionName', e.target.value)} />
                        <Input label={'Arabic Label'} inline={true} value={arabicActionLabel} type={'text'} placeholder={'Type your workflow action in arabic'} onChange={e => handleInputChange('arabicActionLabel', e.target.value)} />
                        <Button style={{marginTop: '10px', display: 'block', margin: '0 auto'}} onClick={handleWorkFlowAction}>{(actionID !== '') ? 'Update' : 'Add'}</Button>
                    </div>
                </WorkFlowActionsContainer>
            </FieldsContainer>
            <AddedFieldsContainer>
                {(actions && actions.length !== 0) && <WorkFlowActionsContainer>
                    <h4 style={{color: '#333', margin: '0 0 15px 0'}}>Workflow Actions</h4>
                    <div>
                        {actions.map(({actionName, actionLabel, arabicActionName, arabicActionLabel}, index) => (
                            <DataContainer key={index} style={{margin: '8px 0', display: 'flex', flexDirection: (isArabic ? 'row-reverse' : 'row')}}>
                                <span>{index + 1}. {actionName}</span>
                                <FiEdit2 style={{margin: '0 5px',  cursor: 'pointer'}} onClick={() => handleEditWorkflowAction(index, actionLabel, actionName, arabicActionName, arabicActionLabel)} />
                                <AiOutlineDelete style={{cursor: 'pointer'}} onClick={() => handleRemoveAction(actionName, index)} />
                            </DataContainer>
                        ))}
                        {actions.map(({actionName, actionLabel, arabicActionName, arabicActionLabel}, index) => (
                            <DataContainer key={index} style={{margin: '8px 0', display: 'flex', flexDirection: (isArabic ? 'row-reverse' : 'row')}}>
                                <span>{index + 1}. {arabicActionName}</span>
                                <FiEdit2 style={{margin: '0 5px',  cursor: 'pointer'}} onClick={() => handleEditWorkflowAction(index, actionLabel, actionName, arabicActionName, arabicActionLabel)} />
                                <AiOutlineDelete style={{cursor: 'pointer'}} onClick={() => handleRemoveAction(actionName, index)} />
                            </DataContainer>
                        ))}
                    </div>
                </WorkFlowActionsContainer>}
            </AddedFieldsContainer>
        </FormContainer>
    );
};

export default WorkflowActions;